import i18n from 'i18next';
import { useMemo } from 'react';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentCargoTypes } from '../../hooks';

export const CargoTypeSelect = ({
  placeholder = i18n.t('translation:default.fields.cargoType.placeholder'),
  label = i18n.t('translation:default.fields.cargoType.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
  mode = '',
  isDefault = false,
  onChange,
  disableDefaultOptions = false,
  singleLineMode = false,
}) => {
  const { data = [], isLoading } = useGetShipmentCargoTypes();

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        !disableDefaultOptions
          ? isDefault === true
            ? [{ label: 'Select', value: '' }, ...options]
            : [{ label: '--All--', value: '**' }, ...options]
          : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
      mode={mode}
      onChange={onChange}
      singleLineMode={singleLineMode}
    />
  );
};
